module.exports = __webpack_public_path__ + "img/about_business.9c19c676.png";